import React from 'react';
import { ExternalLink } from 'lucide-react';
import './TestRunLogLink.css';

// "SHOW ME WHAT JUST HAPPENED."
//
// A test writes its steps to the integration log, and until now reading them meant leaving the modal,
// finding the Logs tab, picking the integration out of a list and pasting a transaction id — by which
// point the run is one of several and telling them apart is the reader's problem.
//
// THE RUN'S OWN ID IS THE LINK. Both tests tag every entry they write with it (the OXI test uses the
// transaction id the message carries; the MCP test mints one per run), so the Logs tab opens filtered
// to this run and nothing else. Without one, the link still goes to this integration's log — which is
// worse than exact and much better than nothing.
//
// A NEW TAB, always. The modal holds a result worth reading beside the log, and half of what a test is
// for is comparing the two; navigating away would throw the answer out to go and look at it.

/**
 * @param {string|number} integrationId
 * @param {string}       [transactionId]  this run's id, when there is one
 * @param {string}       [label]
 */
const TestRunLogLink = ({ integrationId, transactionId, label = 'Open the logs for this run' }) => {
    if (!integrationId) return null;
    const qs = new URLSearchParams({ tab: 'logs', integrationId: String(integrationId) });
    if (transactionId) qs.set('transactionId', String(transactionId));
    return (
        <a
            className="trl"
            href={`/pipelines?${qs}`}
            target="_blank"
            rel="noopener noreferrer"
            title={transactionId
                ? `Opens the Logs tab filtered to ${transactionId}`
                : 'Opens the Logs tab filtered to this pipeline'}
        >
            <ExternalLink size={13} />
            {label}
        </a>
    );
};

export default TestRunLogLink;
